import { render, staticRenderFns } from "./merchant_menu.vue?vue&type=template&id=735b44a8&scoped=true"
import script from "./merchant_menu.vue?vue&type=script&lang=js"
export * from "./merchant_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735b44a8",
  null
  
)

export default component.exports